import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

const ModalFormInputsContainer = (props) => {
    return (
        <div>
            <div className="flex items-start justify-between gap-4 px-6 pt-6 pb-4 border-b border-gray-100">
                <h3 className="text-lg font-semibold text-gray-900">
                    {props.title}
                </h3>
                {props.onClose && (
                    <button
                        type="button"
                        onClick={props.onClose}
                        className="flex-shrink-0 -mr-2 -mt-2 h-8 w-8 rounded-lg flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                    >
                        <FontAwesomeIcon icon={faXmark} className="w-4 h-4"/>
                    </button>
                )}
            </div>
            <div className="px-6 pt-5 pb-4">
                {props.children}
            </div>
        </div>
    );
}

export default ModalFormInputsContainer;
